import React, { useState, useEffect } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

const MapContainer = ({ google, latitude, longitude, setLocation}) => {
    // const [position, setPosition] = useState({ lat: latitude, lng: longitude });
    let position = {
        lat: latitude,
        lng: longitude
    }

    const onMapClick = (mapProps, map, clickEvent) => {
        const { latLng } = clickEvent;
        // setPosition({
        //     lat: latLng.lat(),
        //     lng: latLng.lng()
        // })
        setLocation({
            latitude: latLng.lat(),
            longitude: latLng.lng()
        })
        console.log(`Latitude: ${position.lat}, Longitude: ${position.lng}`);
    };

    return (
        <Map
            google={google}
            zoom={15}
            initialCenter={position}
            center={position}
            style={{ width: '100%', height: '100%' }}
            onClick={onMapClick}
        >
            <Marker position={position} />
        </Map>
    );
};

export default GoogleApiWrapper({
    apiKey: 'AIzaSyBtPqvB5fSoEsqEQ7hEGDYu_FNC6ZTC3hc' // Replace with your Google Maps API key
})(MapContainer);